import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_STANDARD_PROPOSAL_DETAIL_COL_DEF, transferRowData } from "presentation/constant/StandardProposal/StandardProposalDetailColumnDefinition";
import { useStandardProposalDetailVM } from "presentation/hook/StandardProposal/useStandardProposalDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useStandardProposalDetailTracked } from "presentation/store/StandardProposal/StandardProposalDetailProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useRef, useState } from "react";


const StandardProposalDetailTablePanel: React.FC = () => {
    const [standardProposalDtlState] = useStandardProposalDetailTracked();
    const standardProposalDtlVM = useStandardProposalDetailVM();
    const { currentStandardProposal, currentSelectItemRows, isShowAddTariffItemPanel } = standardProposalDtlState;
    let gridRef: any = useRef();
    const messageBarVM = useMessageBarVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate, allowDelete } = anaInfoState;

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        // const columnDefs = (INITIAL_STANDARD_PROPOSAL_DETAIL_COL_DEF?.slice());

        // if (!standardProposalState.tariffItemSelectedRows ||
        //     standardProposalState.tariffItemSelectedRows.length <= 0) {        
        //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
        if (!onTableSelectionClicked) {
            gridRef.current?.gridRef.current.api?.deselectAll();
        }
        // }
    })

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        standardProposalDtlVM.updateSelectedRows(selectedRows);
    }, [standardProposalDtlVM])

    const handleAdd = useCallback(() => {
        // if (!currentStandardProposal.companyCode) {
        //     messageBarVM.showError("Company Code is mandatory.");
        //     return;
        // }
        // if (!currentStandardProposal.effectiveDate) {
        //     messageBarVM.showError("Effective Date is mandatory.");
        //     return;
        // }
        // if (!currentStandardProposal.expiryDate) {
        //     messageBarVM.showError("Expiry Date is mandatory.");
        //     return;
        // }
        if (currentStandardProposal.effectiveDate && currentStandardProposal.expiryDate && new Date(currentStandardProposal.expiryDate) < new Date(currentStandardProposal.effectiveDate)) {
            messageBarVM.showError("The Expiry Date should be later than the Effective Date.");
            return;
        }
        // if (!currentStandardProposal.currencyCode) {
        //     messageBarVM.showError("Currency is mandatory.");
        //     return;
        // }
        // if (!currentStandardProposal.proposalCreatedByMethod) {
        //     messageBarVM.showError("Proposal By is mandatory.");
        //     return;
        // }
        // if (currentStandardProposal.tariffNatureList?.length === 0) {
        //     messageBarVM.showError("Tariff Nature is mandatory.");
        //     return;
        // }
        standardProposalDtlVM.onSaveClicked();
        standardProposalDtlVM.onAddTariffItemClick(currentStandardProposal);
    }, [currentStandardProposal, messageBarVM, standardProposalDtlVM]);

    const handDelete = useCallback(() => {
        if (currentSelectItemRows.length === 0) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        standardProposalDtlVM.onTariffItemDeleteClick(currentSelectItemRows);
    }, [messageBarVM, standardProposalDtlVM, currentSelectItemRows]);

    const isRowSelectable = useCallback((params: any) => {
        return !isShowAddTariffItemPanel;
    }, [isShowAddTariffItemPanel]);

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowAddTariffItemPanel, standardProposalDtlState.isAddIs, standardProposalDtlState.isAddTier])

    return <TableWrapper>
        <NbisTable
            id='standard-proposal-detail-table'
            isNewColumnSetting={true}
            columns={INITIAL_STANDARD_PROPOSAL_DETAIL_COL_DEF?.slice()}
            data={transferRowData(standardProposalDtlState.standardProposalItemList?.slice() ?? [])}
            headerActionButtons={(allowDelete) && [
                {
                    id: 'onDeleteButton',
                    icon: 'Icon-trash',
                    title: 'Delete'
                },
            ]}
            onDeleteButton={handDelete}
            showPaginator={false}
            editable={false}
            showAddIcon={(allowCreate) && true}
            onAddClick={handleAdd}
            showDeleteButton={false}
            showReloadIcon={false}
            showUploadIcon={false}
            isScrollHighlighted={true}
            selectionMode={false}
            rowSelection={"multiple"}
            isRowHighligted={true}
            handleSelectionChanged={handleSelectionChange}
            gridHeight="customHeight"
            customHeight="calc(100vh - 125px)"
            ref={gridRef}
            handleRowSelectable={isRowSelectable}
        />
    </TableWrapper>;
}

export default memo(StandardProposalDetailTablePanel);
